<template>
	<div class="color-square" :style="{backgroundColor:currentColor.rgbString, color:this.$store.state.Color.contrastTextColor(this.currentColor.hsl,'hsl')}" @click="copyColor">
		<div>{{currentColor.rgbString}}</div>
		<div>{{currentColor.hslString}}</div>
		<div>{{currentColor.hexString}}</div>
		<div>{{currentColor.xyzString}}</div>
		<div>{{currentColor.labString}}</div>
		<div>{{currentColor.lchabString}}</div>
	</div>
</template>
<script type="text/javascript">
	export default{
		props:['color'],
		data(){
			return {

			};
		},
		methods:{
			copyColor(){
				let input = document.createElement("input");
				input.value = this.currentColor.hexString;
				input.style.maxWidth = "0.1px";
				input.style.maxHeight = "0.1px";
				input.style.position="absolute";
				input.style.left="-9999px";
				document.body.appendChild(input);
				input.select();
				input.setSelectionRange(0, 99999);
				document.execCommand("copy");
				document.body.removeChild(input);
			}
		},
		computed:{
			currentColor(){
				if(!this.color){
					return (new this.$store.state.Color());
				}else{
					return this.color;
				}
			}
		}
	}
</script>
<style type="text/css">
	.color-square{
		text-align: center;
		padding: 2%;
		width: 17vw;
		height: 17vw;
		min-width: 15em;
		min-height: 15em;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		position: relative;
	}
	.color-square::before{
		content: "";
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background-color: transparent;
		cursor: pointer;
		transition: background-color 0.15s ease-in-out;
		z-index: 10;
	}
	.color-square:hover::before{
		background-color: rgba(0,0,0,0.6);
	}
	.color-square:hover::after{
		content: "Click to Copy Hexcode";
		font-weight: bold;
		text-transform: uppercase;
		font-size: 2em;
		color: #FFF;
		position: absolute;
		z-index: 20;
		text-align: center;
		left: 0;
		right:0;
		top: 0;
		bottom: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}
	.color-square:active::after{
		content: "Copied";
		font-weight: bold;
		text-transform: uppercase;
		font-size: 2em;
		color: #FFF;
		position: absolute;
		z-index: 20;
		text-align: center;
		left: 0;
		right:0;
		top: 0;
		bottom: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}
</style>